export const AUTH = {
  loginGoogleBtn: "login-google-btn",
  logoutBtn: "logout-btn",
  themeToggle: "theme-toggle-btn",
  tabLogin: "auth-tab-login",
  tabRegister: "auth-tab-register",
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  firstNameInput: "auth-firstname-input",
  lastNameInput: "auth-lastname-input",
  submitBtn: "auth-submit-btn",
  errorMessage: "auth-error-message",
  forgotLink: "auth-forgot-link",
  forgotEmailInput: "auth-forgot-email-input",
  forgotSubmitBtn: "auth-forgot-submit-btn",
  forgotResetUrl: "auth-forgot-reset-url",
};

export const RESET = {
  container: "reset-container",
  passwordInput: "reset-password-input",
  submitBtn: "reset-submit-btn",
  successMessage: "reset-success-message",
  errorMessage: "reset-error-message",
  backToLogin: "reset-back-to-login",
};

export const CHANGE = {
  section: "profile-change-password-section",
  currentInput: "profile-current-password",
  newInput: "profile-new-password",
  submitBtn: "profile-change-password-btn",
};

export const CARD = {
  section: (id) => `card-section-${id}`,
  statusBadge: (id) => `card-status-${id}`,
  cardId: (id) => `card-id-${id}`,
  activatedAt: (id) => `card-activated-${id}`,
  lastScan: (id) => `card-last-scan-${id}`,
  totalScans: (id) => `card-total-scans-${id}`,
  associateBtn: (id) => `card-associate-btn-${id}`,
  deactivateBtn: (id) => `card-deactivate-btn-${id}`,
  confirmAssociateBtn: (id) => `card-confirm-associate-${id}`,
  confirmDeactivateBtn: (id) => `card-confirm-deactivate-${id}`,
};

export const LANDING = {
  section: (id) => `landing-section-${id}`,
  urlDisplay: (id) => `landing-url-${id}`,
  openBtn: (id) => `landing-open-btn-${id}`,
  copyBtn: (id) => `landing-copy-btn-${id}`,
  publicContainer: "landing-public-container",
  publicReviewCta: "landing-public-review-cta",
  publicDeactivated: "landing-public-deactivated",
};

export const QR = {
  section: (id) => `qr-section-${id}`,
  statusBadge: (id) => `qr-status-${id}`,
  preview: (id) => `qr-preview-${id}`,
  urlDisplay: (id) => `qr-url-${id}`,
  downloadPngBtn: (id) => `qr-download-png-${id}`,
  downloadSvgBtn: (id) => `qr-download-svg-${id}`,
  copyBtn: (id) => `qr-copy-btn-${id}`,
  printBtn: (id) => `qr-print-btn-${id}`,
};

export const DASH = {
  container: "dashboard-container",
  businessSelector: "business-selector",
  businessSelectorItem: (id) => `business-item-${id}`,
  addBusinessBtn: "add-business-btn",
  newBusinessNameInput: "new-business-name-input",
  newBusinessAddressInput: "new-business-address-input",
  saveBusinessBtn: "save-business-btn",
  dateRangeTrigger: "date-range-trigger",
  datePreset30d: "date-preset-30d",
  datePreset90d: "date-preset-90d",
  datePreset6m: "date-preset-6m",
  datePreset1y: "date-preset-1y",
  datePresetCustom: "date-preset-custom",
  kpiTotal: "kpi-total-reviews",
  kpiAverage: "kpi-average-rating",
  kpiMostCommon: "kpi-most-common",
  kpiTotalDelta: "kpi-total-delta",
  kpiAverageDelta: "kpi-average-delta",
  pieChart: "reviews-pie-chart",
  reviewsList: "reviews-list",
  reviewItem: (id) => `review-item-${id}`,
  profileLink: "profile-link",
};

export const PROFILE = {
  container: "profile-container",
  backLink: "profile-back-link",
  firstNameInput: "profile-first-name",
  lastNameInput: "profile-last-name",
  saveProfileBtn: "profile-save-btn",
  businessCard: (id) => `profile-business-${id}`,
  bizNameInput: (id) => `profile-biz-name-${id}`,
  bizAddressInput: (id) => `profile-biz-address-${id}`,
  bizWebsiteInput: (id) => `profile-biz-website-${id}`,
  bizGoogleUrlInput: (id) => `profile-biz-gbp-${id}`,
  bizSaveBtn: (id) => `profile-biz-save-${id}`,
  bizConnectGbpBtn: (id) => `profile-biz-connect-gbp-${id}`,
};
